import { render, staticRenderFns } from "./bread_crumbs.vue?vue&type=template&id=71b3c380&scoped=true"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"
import style0 from "./bread_crumbs.vue?vue&type=style&index=0&id=71b3c380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3c380",
  null
  
)

export default component.exports